import { DynamoDBClient, QueryCommand } from '@aws-sdk/client-dynamodb';
import { getStoredCredentials } from './auth';

const cache: { [date: string]: any } = {};

const getClient = async () => {
    let credentials = await getStoredCredentials();

    if (!credentials) {
        throw new Error('Failed to get AWS credentials');
    }

    return new DynamoDBClient({
        region: 'us-west-2',
        credentials: {
            accessKeyId: credentials?.AccessKeyId!,
            secretAccessKey: credentials?.SecretKey!,
            sessionToken: credentials?.SessionToken!,
        },
    });
};

export const fetchData = async (date: string) => {
    if (cache[date]) {
        console.log('Returning cached data');
        return cache[date];
    }

    const client = await getClient();
    const command = new QueryCommand({
        TableName: 'BusmapStack-BusTrackTableD105B48E-1DTWDNRYOUBAJ',
        KeyConditionExpression: '#date = :date',
        ExpressionAttributeNames: {
            '#date': 'date',
        },
        ExpressionAttributeValues: {
            ':date': { S: date },
        },
    });

    const response = await client.send(command);
    console.log(response.Items);
    const data = response.Items?.map((item) => {
        // @ts-ignore
        const currentItem = JSON.parse(item.location.S);

        return {
            // @ts-ignore
            lat: parseFloat(currentItem.lat),
            // @ts-ignore
            lng: parseFloat(currentItem.lng),
            // @ts-ignore
            timestamp: currentItem.timestamp,
            // @ts-ignore
            bearing: parseFloat(currentItem.bearing),
        }
    });

    cache[date] = data;
    return data;
};